export default __webpack_public_path__ + "static/media/Restauration.c6ad2669.jpg";